import { post, get } from './index'

export function savePersonalize(data) {
  return post('/personalize/save', data)
}

export function getByDomain(params) {
  return get('/personalize/domain', params)
}
